export default function() {
  const collectionFilterElem = document.querySelector(
    '[data-collection-filter]'
  );

  if (collectionFilterElem === null) {
    return false;
  }

  const mediaQuery = window.matchMedia(
    '@media print, screen and (min-width: 64em)'
  );

  const toggleButton = collectionFilterElem.querySelector(
    '[data-collection-filter-toggle]'
  );

  toggleButton.addEventListener('click', () => {
    if (!mediaQuery.matches) {
      collectionFilterElem.classList.toggle('is-open');
    }
  });
}
